import StarterKit from '@tiptap/starter-kit';
import Image from '@tiptap/extension-image';
import Link from '@tiptap/extension-link';
import Placeholder from '@tiptap/extension-placeholder';
import Table from '@tiptap/extension-table';
import TableRow from '@tiptap/extension-table-row';
import TableCell from '@tiptap/extension-table-cell';
import TableHeader from '@tiptap/extension-table-header';

export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5006';

// Extensões usadas tanto no editor quanto no render (precisam bater pro conteúdo abrir igual).
export const extensoesTiptap = [
  StarterKit,
  Image.configure({ inline: false, allowBase64: false }),
  Link.configure({ openOnClick: false, autolink: true, HTMLAttributes: { rel: 'noopener noreferrer', target: '_blank' } }),
  Placeholder.configure({ placeholder: 'Escreva o conteúdo aqui…' }),
  Table.configure({ resizable: true }),
  TableRow,
  TableHeader,
  TableCell,
];

// As imagens são servidas com auth (?t=token). No conteúdo guardamos o caminho relativo;
// na exibição viram URL absoluta com token, e na hora de salvar voltam pra relativo.
const PREFIXO = '/documentos/imagem/';

function mapearImagens(node, fn) {
  if (Array.isArray(node)) return node.map(n => mapearImagens(n, fn));
  if (!node || typeof node !== 'object') return node;
  const out = { ...node };
  if (out.type === 'image' && out.attrs && out.attrs.src) {
    out.attrs = { ...out.attrs, src: fn(out.attrs.src) };
  }
  if (out.content) out.content = mapearImagens(out.content, fn);
  return out;
}

export function paraExibicao(doc, token) {
  if (!doc) return doc;
  return mapearImagens(doc, (src) => (String(src).startsWith(PREFIXO) ? `${API_URL}${src}?t=${token}` : src));
}

export function paraSalvar(doc) {
  if (!doc) return doc;
  return mapearImagens(doc, (src) => {
    const m = String(src).match(/\/documentos\/imagem\/[^?"]+/);
    return m ? m[0] : src;
  });
}

export function urlImagem(relativo, token) {
  return `${API_URL}${relativo}?t=${token}`;
}
